import { render } from "./mymoney.vue?vue&type=template&id=148ae6d5&scoped=true"
import script from "./mymoney.vue?vue&type=script&lang=js"
export * from "./mymoney.vue?vue&type=script&lang=js"

import "./mymoney.vue?vue&type=style&index=0&id=148ae6d5&scoped=true&lang=less"

import exportComponent from "D:\\Git仓库\\象新力官网\\html_xxldx_xxlx_xxlg\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-148ae6d5"]])

export default __exports__